import { FormItem, FuelCompositionState, CalculationData, FuelCompositionItem } from "models";

export const OXYGEN_ID = "O";
export const REDUCTION_EFFICIENCY_ID = "red_eff";
export const HHV_ID = "HHV";
export const CNCG_HHV_ID = "CNCG_HHV";

// These fields are excluded from the Oxygen value calculation
export const excludedFields = [OXYGEN_ID, REDUCTION_EFFICIENCY_ID, HHV_ID, CNCG_HHV_ID];

export const validateForm = (form: FuelCompositionState): boolean => {
  return !form.data.filter((item) => !item.valid).length;
};

export const validateFormData = (form: FormItem[]): FormItem[] => {
  return form.map((formItem: FormItem) => {
    return { ...formItem, valid: formItem.value >= formItem.min && formItem.value <= formItem.max };
  });
};

/**
 * Checks if the input value is between its min - max limits and sets the 'valid' boolean accordingly
 * @param formItems (FormItem[])
 * @param id
 * @param value
 */
export const validateValue = (formItems: FormItem[], id: string, value: number) => {
  return formItems.map((item) => {
    if (item.id === id) {
      return { ...item, value: value, valid: value >= item.min && value <= item.max };
    }

    return item;
  });
};

export const calculateOxygenValue = (formItems: FormItem[]) => {
  let addedValues = 0;

  // Consider using reduce here!
  formItems.forEach((item) => {
    if (!excludedFields.find((exludeId) => item.id === exludeId)) {
      addedValues += isNaN(item.value) ? 0 : item.value;
    }
  });

  const oxygenValue = 100 - addedValues;

  return formItems.map((item) => (item.id === OXYGEN_ID ? { ...item, value: parseFloat(oxygenValue.toFixed(2)) } : item));
};

/**
 * Turns the form and time selection into sendable json
 * @param form
 */
export const prepareCalculationData = (form: FuelCompositionState): CalculationData => {
  const preparedData: CalculationData = {
    clientId: null,
    millId: null,
    lineId: null,
    segmentId: null,
    startTime: "",
    endTime: "",
    fuelComposition: {},
    damperConfigs: [],
    startupBurnerConfiguration: { tags: [], total_cooling_air: null },
    superHeater: false,
  };

  let newFuelComposition: FuelCompositionItem = {};
  form.data.forEach((item: FormItem) => (newFuelComposition[item.id] = "" + item.value));

  return { ...preparedData, fuelComposition: newFuelComposition };
};
